export default "__VITE_ASSET__zjjcoMY8__"